<template>
<div>
  <el-card body-style="padding: 0">
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-form-item label="用户编号" prop="userId">
            <el-input v-model="queryForm.userId" placeholder="请输入用户编号"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="用户名" prop="userName">
            <el-input v-model="queryForm.userName" placeholder="请输入用户名称"/>
          </el-form-item>
        </el-col>
        <!--<el-col :span="5">
          <el-form-item label="账户类型" prop="accountType">
            <el-select v-model="queryForm.accountType" clearable placeholder="请选择账户类型">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>-->
        <el-col :span="9" >
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>

  <el-card>
    <el-table :data="tableData"
              ref="table"
              border default-expand-all stripe
              :header-cell-style="{'text-align':'center'}"
              :max-height="tableHeight"
              style="width: 100%;margin-bottom: 20px;"
              :cell-style="{'text-align':'center'}"
              @selection-change="handleSelectionChange">
      <el-table-column label="全选" width="50" type="selection"/>
      <el-table-column prop="userId" label="用户ID">
        <!--<template slot-scope="scope">
          <span>{{ getStrEndWithNumbers(scope.row.userId) }}</span>
        </template>-->
      </el-table-column>
      <el-table-column prop="userName" label="用户名"/>
      <el-table-column prop="balanceMoney" label="余额"/>
      <el-table-column prop="freezeMoney" label="冻结"/>
      <el-table-column prop="isUsedStr" label="状态">
        <template slot-scope="scope">
          <span style="color: #1F9FFF">{{ scope.row.isUsedStr }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remarks" label="备注"/>
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" plain
                     @click="handleEdit(scope.$index, scope.row,'调整余额--('+scope.row.userName+')')">
            调整
          </el-button>
          <el-button size="mini" type="primary" plain
                     @click="goToDetails(scope.$index, scope.row)">
            账户明细
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>

  <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
    <el-form ref="dialogForm" :model="dialogForm" label-width="120px" size="mini">
      <el-form-item label="账户余额">
        <el-input disabled type="number" v-model="dialogForm.balanceMoney" style="width: 50%;color: black"></el-input>
      </el-form-item>
      <el-form-item label="变动类型" prop="isChangeConf"
                    :rules="{required: true, message: '变动类型不能为空', trigger: 'change'}">
        <el-radio-group v-model="dialogForm.isChangeConf">
          <el-radio :label="false">减少</el-radio>
          <el-radio :label="true">增加</el-radio>
        </el-radio-group>
        <span style="color: red;margin-left: 1%;">注：变动类型必选</span>
      </el-form-item>
      <el-form-item label="余额变量" prop="changeBalanceMoney"
                    :rules="{required: true, message: '值不能为空或0', trigger: 'blur'}">
        <el-input type="number" v-model="dialogForm.changeBalanceMoney" style="width: 50%;"></el-input>
        <span style="color: red;margin-left: 1%;">注：值不能为0</span>
      </el-form-item>
      <el-form-item label="交易类型" prop="serialType">
        <el-select v-model="dialogForm.serialType" clearable placeholder="手动调整" disabled>
          <el-option
              v-for="item in serialTypeEnum"
              :key="item.serialType"
              :label="item.serialTypeName"
              :value="item.serialType"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="调整备注">
        <el-input v-model="dialogForm.remarks" style="width: 50%;"></el-input>
      </el-form-item>
      <el-form-item label="操作密码" prop="moneyPassword"
                    :rules="{required: true, message: '值不能为空', trigger: 'blur'}">
        <el-input type="password" v-model="dialogForm.moneyPassword" style="width: 50%;"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitDialogForm" size="mini" type="primary">提交</el-button>
      <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {getStrEndWithNumbers} from "../../lib/utils";
import {getBusinessMoneyList, updateCustomerMoney} from "../../api/b2cbusiness/b2c_customerinfo";
import MinxinScroll from "@/components/MinxinScroll";
export default {
  name: "ShopMoneylist",
  mixins:[MixinCUD, MinxinScroll],
  data() {
    return {
      serialTypeEnum:[
        {
          serialTypeName:"后置评价结算",
          serialType:2021080001
        },
        {
          serialTypeName:"上级奖励",
          serialType:2021080002
        },
        {
          serialTypeName:"佣金奖励",
          serialType:2021080003
        },
        {
          serialTypeName:"账户充值",
          serialType:2021080005
        },
        {
          serialTypeName:"账户提现",
          serialType:2021080004
        },
        {
          serialTypeName:"本金返还",
          serialType:2021110004
        },
        {
          serialTypeName:"佣金返还",
          serialType:2021110005
        },
        {
          serialTypeName:"手动结算",
          serialType:2021110007
        },
        {
          serialTypeName:"手动调整",
          serialType:2023060701
        },
        {
          serialTypeName:"推荐奖励",
          serialType:2022010007
        },
        {
          serialTypeName:"发布任务",
          serialType:2021080006
        }
      ],
      tableData: [],
      queryFormRefName:"queryForm",
      queryForm: {
        userId: null,
        userName: ''
      },
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm: {
        balanceMoney: "",
        isChangeConf: false,
        changeBalanceMoney: "",
        moneyPassword: ""
      },
      tableHeight: 850,
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  mounted() {
    //this.tableHeight = document.body.clientHeight - 220;
    this.getData();
  },
  methods: {
    goToDetails(index, data){
      this.$router.push({path:"/home/customermdetail", query: {userId:data.userId}})
    },
    getStrEndWithNumbers(numbers) {
      return getStrEndWithNumbers(numbers, 8);
    },
    getData() {
      getBusinessMoneyList(this.queryForm, this.pagination).then(res => {
        if (res.success) {
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    submitDialogForm(){
      this.dialogForm.serialType=2023060701
      this.$refs[this.dialogRefName].validate((valid) => {
        if (valid) {
          this.$confirm("确定提交数据么?")
              .then(_ => {
                this.updateData();
                //取消新增或修改也要重置表单
              }).catch(err => {this.handleCloseDialog();});
        } else {
          return false;
        }
      });
    },
    updateData(){
      updateCustomerMoney(this.dialogForm).then(res=>{
        if (res.success){
          this.$message.success("更新数据成功！");
          this.getData();
          this.handleCloseDialog();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm()
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
</style>
